import React from "react";
import { Clipboard, FolderOpen, Users } from "lucide-react";

export function BottomNavigation({ activeTab, onTabChange }) {
  return (
    <div className="bottom-nav">
      <div className="bottom-nav-inner">
        {/* Taskboard Button */}
        <button
          onClick={() => onTabChange("taskboard")}
          className={`nav-btn ${activeTab === "taskboard" ? "active" : ""}`}
        >
          <Clipboard className="icon" />
          <span>Taskboard</span>
        </button>

        {/* File Box Button */}
        <button
          onClick={() => onTabChange("filebox")}
          className={`nav-btn ${activeTab === "filebox" ? "active" : ""}`}
        >
          <FolderOpen className="icon" />
          <span>File Box</span>
        </button>

        {/* AI Agent Button */}
        <button
          onClick={() => onTabChange("aiagent")}
          className={`nav-btn ${activeTab === "aiagent" ? "active" : ""}`}
        >
          <Users className="icon" />
          <span>AI Agent</span>
        </button>
      </div>
    </div>
  );
}
